import React, { useEffect, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Banner from "../common/Banner";
import cornerPlots from "../../images/cornerPlots.jpeg";
import eastFacingPlots from "../../images/eastFacingPlots.jpeg";
import boundryWallPlots from "../../images/boundryWallPlots.jpeg";
import homeLoan from "../../images/Homepage/HomeLoan.png";
import zeroInt from "../../images/Homepage/Zero.png";
import regist from "../../images/Homepage/Legal.png";
import inspection from "../../images/Homepage/Inspection.png";
import postPropertyBanner from "../../images/Homepage/post-property.png";
import postPropertyBannermob from "../../images/Homepage/post-property-mob.jpg";
import questionMark from "../../images/Homepage/output.gif";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPlotTopProjects,
  fetchPlotPremiumProjects,
  fetchPlotAffordableProjects,
} from "../../redux/homeSlice";
import marker from "../../images/marker.png";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Testimonial from "../Testimonial";
import TopProjects from "../project/TopProjects";
import { AppContext } from "../../context/AppContext";
import config from "../../config/config";
import { fetchProfileProperties } from "../../redux/profilePropertySlice";
import AllLocalitiesMap from "../common/AllLocalitiesMap";
import { useNavigate } from "react-router-dom";
import PremiumProjects from "../project/PremiumProjects";
import AffordableProjects from "../project/AffordableProjects";
import RecommendedSellers from "../RecommendedSellers";
import FeaturedCollection from "../common/FeaturedCollection";
import OfferedFacilities from "./OfferedFacilities";
import AdsBannerSection from "../common/AdsBannerSection ";
import ShowcaseAdSection from "../common/ShowcaseAdSection";
import NewBanner from "../common/NewBanner";
import NewPremiumProjects from "../project/NewPremiumProjects";
import NewRecommendedSellers from "../NewRecommendedSellers";
import NewTestimonial from "../NewTestimonial";

const Plots = () => {
  const { user } = useContext(AppContext);
  const token = config.getAuthToken();
  const dispatch = useDispatch();
  const {
    plotTopProjects,
    plotPremiumProjects,
    plotAffordableProjects,
    status,
    error,
  } = useSelector((state) => state.home);
  const { properties, status1, error1 } = useSelector(
    (state1) => state1.profileProperty
  );
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchPlotTopProjects());
    dispatch(fetchPlotPremiumProjects());
    dispatch(fetchPlotAffordableProjects());
  }, [dispatch]);

  const [allLocalities, setAllLocalities] = useState([]);

  useEffect(() => {
    const fetchAllLocalities = async () => {
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_BASE_URL
          }/search/allLocalities?city_id=${1}&service=${"sell"}&type=${"plot"}`
        );
        setAllLocalities(response.data?.data || []); // Update suggestions state

        // console.log(response?.data?.data[0]);
      } catch (error) {
        console.error("Error fetching localities:", error);
      }
    };

    fetchAllLocalities();
  }, []);

  const customIcon = new L.Icon({
    iconUrl: marker, // URL to your custom marker image
    iconSize: [85, 85], // Size of the icon
    iconAnchor: [16, 32], // Anchor position for the icon
    popupAnchor: [0, -32], // Position of the popup relative to the icon
  });

  const handleDispatch = () => {
    if (user?.data?.id != null) {
      dispatch(fetchProfileProperties(user?.data?.id));
    }
  };
  useEffect(() => {
    if (properties?.wishlist) {
      setWishlist(properties.wishlist.map(Number)); // Convert to integers
    }
  }, [properties]);
  useEffect(() => {
    handleDispatch();
  }, [user?.data?.id]);

  const handleClick = () => {
    navigate("/buy/searches/srlid-1", {
      state: { name: "city", service: "plot", type: "" },
    });
  };
  const handleNavigation = (path, feature) => {
    localStorage.setItem("feature_clicked", feature);
    navigate(path);
  };

  return (
    <div>
      {/* Banner */}
      {/* <Banner category="plot" /> */}
      <NewBanner category="plot" />

      {/* Top Project */}

      <TopProjects
        topProjects={plotTopProjects}
        wishlist={wishlist}
        user={user}
        token={token}
        handleDispatch={handleDispatch}
      />

      <AdsBannerSection />

      {/* Featured Collections */}

      <FeaturedCollection
        category="plot"
        title="Exclusive Showcase Of Catagorized Plots"
      />

      {/* Premiums Projects */}

      {/* <PremiumProjects
        premiumProjects={plotPremiumProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="plot"
      /> */}

      <NewPremiumProjects premiumProjects={plotPremiumProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="plot"/>

      {/* Affordable Projects */}
      <AffordableProjects
        title={"Explore Our Affordable Projects In Jaipur"}
        affordableProjects={plotAffordableProjects}
        user={user}
        token={config.getAuthToken()}
        wishlist={wishlist}
        handleDispatch={handleDispatch}
        category="plot"
      />

      {/* Top Localities */}
      {allLocalities?.length > 0 && (
        <AllLocalitiesMap
          allLocalities={allLocalities}
          category={"plot"}
          property_type={"plot"}
        />
      )}

      <ShowcaseAdSection />

      <section className="postProperty-section sectiontopgap">
        <Link to="/postProperty">
          <div className="container-fluid p-0">
            <div className="desk">
              <img src={questionMark} className="banner-mark" />
              <img src={postPropertyBanner} className="banner-image" />
            </div>

            <div className="mob">
              <img src={postPropertyBannermob} className="banner-image" />
            </div>
          </div>
        </Link>
      </section>

      {/* Offered Facilities */}
      <OfferedFacilities user={user} token={token} />
      {/* <section className="facility-section sectiontopgap">
               <div className="container">
       
                 <div className="sectiontitle">
                   <div className="titleunderline" data-aos='fade-right'>
                     <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
                     </svg>
                   </div>
                   <h1>Offered Facilities</h1>
                 </div>
       
                 <div className='facilities' style={{ marginTop: '80px' }}>
                   <div className='faci_row'>
                     <div className='faci_col'>
                       <div className='cardbase'>
                         <div className='ofaciicon'>
                           <img src={homeLoan} className='faci_img' />
                         </div>
                         <div className='cardcont'>
                           <div className='faci_title'>
                             <h3>Home Loan</h3>
                           </div>
                           <div className='faci_points'>
       
       
                             <p>Attractive Interest Rates</p>
                             <p>Greater Loan Eligibility</p>
                             <p>Loan Offers From Banks</p>
       
                           </div>
       
                         </div>
                         <div className='cardbtn'>
                           <Link to="/">
                             <button className="btn faci_button" type="button">
                               <span>Apply Now</span>
                             </button>
                           </Link>
                         </div>
                       </div>
                     </div>
                     <div className='faci_col'>
                       <div className='cardbase'>
                         <div className='ofaciicon'>
                           <img src={zeroInt} className='faci_img' />
                         </div>
                         <div className='cardcont'>
                           <div className='faci_title'>
                             <h3>Zero Brokerage <br />Rentals</h3>
                           </div>
                           <div className='faci_points'>
       
       
                             <p>Hassel Free Property</p>
                             <p>Management Services.</p>
       
                           </div>
       
                         </div>
                         <div className='cardbtn'>
                           <Link to="/">
                             <button className="btn faci_button" type="button">
                               <span>Contact Now</span>
                             </button>
                           </Link>
                         </div>
                       </div>
                     </div>
                     <div className='faci_col'>
                       <div className='cardbase'>
                         <div className='ofaciicon'>
                           <img src={regist} className='faci_img' />
                         </div>
                         <div className='cardcont'>
                           <div className='faci_title'>
                             <h3>Legal & Registration</h3>
                           </div>
                           <div className='faci_points'>
       
                             <p>End To End Legal  </p>
                             <p>Assistance in Property</p>
                             <p>Related Matters.</p>
       
                           </div>
       
                         </div>
                         <div className='cardbtn'>
                           <Link to="/">
                             <button className="btn faci_button" type="button">
                               <span>Contact Now</span>
                             </button>
                           </Link>
                         </div>
                       </div>
                     </div>
                     <div className='faci_col'>
                       <div className='cardbase'>
                         <div className='ofaciicon'>
                           <img src={inspection} className='faci_img' />
                         </div>
                         <div className='cardcont'>
                           <div className='faci_title'>
                             <h3>Property Inspection</h3>
                           </div>
                           <div className='faci_points'>
       
       
       
                             <p>Get Your Property </p>
                             <p> Evaluated Inside-Out By</p>
                             <p>Professionals/Experts.</p>
       
                           </div>
       
                         </div>
                         <div className='cardbtn'>
                           <Link to="/">
                             <button className="btn faci_button" type="button">
                               <span>Contact Now</span>
                             </button>
                           </Link>
                         </div>
                       </div>
                     </div>
       
       
       
                   </div>
                 </div>
       
               </div>
             </section> */}

      {/* Recommended Sellers */}
      {/* <RecommendedSellers /> */}
      <NewRecommendedSellers />
      {/* <section className="seller-section sectiontopgap">
        <div className="container">

          <div className="sectiontitle">
            <div className="titleunderline">
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1>Recommended Sellers</h1>
          </div>

          <div className="slider-controls">
            <button className="slider-btn prev-btn" onClick={handlePrevClick}>
              ❮
            </button>
            <button className="view-all-btn">View All</button>
            <button className="slider-btn next-btn" onClick={handleNextClick}>
              ❯
            </button>
          </div>

          <div className='content content_margin'>
            <Slider ref={sellerRef} {...seller}>
              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller1pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />

                      <h4>Aditi Sharma</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>  5+ years of Experience in Jaipur location</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Trusted Agent (DreamSakha verified)</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>500+ Buyers Served with 4+ ratings</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Authentic Listings</li>
                      <li>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3438_238)">
                            <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3438_238">
                              <rect width="12" height="12" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller2pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />
                      <h4>Saurav Jain</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>5+ years of Experience in Jaipur location</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Trusted Agent (DreamSakha verified)</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>500+ Buyers Served with 4+ ratings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Authentic Listings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="outer-seller">
                <div className="sellerbox">
                  <div className="seller-top">
                    <div className="seller-pic">
                      <img src={seller3pic} alt="DreamSakha" className='img-fluid' />
                    </div>
                    <div className="sellerdata">
                      <img src={housingExpert} alt="DreamSakha" className='img-fluid' />

                      <h4>Manoj Jain</h4>
                    </div>
                  </div>
                  <div className="seller-bot">
                    <ul>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>5+ years of Experience in Jaipur location</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Trusted Agent (DreamSakha verified)</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>500+ Buyers Served with 4+ ratings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Authentic Listings</li>
                      <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3438_238)">
                          <path d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125" stroke="#343434" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3438_238">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>Highly Professional</li>
                    </ul>
                  </div>
                </div>
              </div>

            </Slider>
          </div>

        </div>
        </section> */}

      {/* Testimonials */}
      {/* <Testimonial /> */}
      <NewTestimonial />
    </div>
  );
};

export default Plots;
